import {AfterViewInit, Directive, ElementRef, Input} from '@angular/core';
import {SizeReceiver} from './size-receiver.model';

@Directive({
  selector: '[ctSetSizeTo]'
})
export class SetSizeToDirective implements AfterViewInit {

  @Input() sizeReceiver: SizeReceiver;

  constructor(private el: ElementRef) {
  }

  ngAfterViewInit(): void {
    this.sizeReceiver.clientWidth = this.el.nativeElement.getBoundingClientRect().width;
    this.sizeReceiver.clientHeight = this.el.nativeElement.getBoundingClientRect().height;
  }
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/set-size-to.directive.ts